module.exports = {
	"account.user.driving.licence.already.exist": "Der er en anden konto med dette kørekortnummer.",
	"account.user.login.already.exist": "Denne e-mail bruges allerede af en anden konto.",
	"account.user.suspended": "Kunne ikke udføre denne handling, fordi brugeren er suspenderet",
	"action.add.payment": "Tilføj betalingsmetode",
	"action.complete.my.account": "Udfyld min konto",
	"action.confirm.welcome.msg": "Lad os gå",
	"action.create.my.account": "Opret min konto",
	"action.search.update.bookings": "Bekræft tilgængelighed",
	"action.update.payment": "Opdater betalingsmetode",
	"anonymous.search.location.not.available": "The search is not available for this location",
	"booking.accept_usage_terms.link.label": "Terms of use",
	"booking.accept_usage_terms.text": "Ved at klikke på \"Bekræft\", erklærer du på ære, at du accepterer gældende vilkår og betingelser for servicen, og at du har et gyldigt kørekort, hvis du bruger bildelingstjenesten. Mere i {link}.",
	"booking.accept_usage_terms.title": "Betingelser for brug",
	"booking.action.cancel.forbidden": "Du har ikke længere mulighed for annullere bookingen",
	"booking.action.edit.forbidden": "Du kan ikke længere ændre en booking",
	"booking.add.calendar": "Føj til kalenderen",
	"booking.confirm": "Bekræft booking",
	"booking.confirm_and_pay": "Bekræft og betal",
	"booking.deposit": "Sikkerhedsdepositum",
	"booking.deposit.b": "Der opkræves et bankindskud på {damageSafetyDeposit} {currency} , når du bekræfter din reservation.\n Dette depositum kan bruges til at dække eventuelle skader, der forårsages af køretøjet under din rejse. \n\n Hvis køretøjet returneres uden skader eller overarbejde, opkræves {bookingPrice} {currency}",
	"booking.deposit.d": "Der foretages et bankindskud på {bufferPrice} {currency} , når du bekræfter din reservation.\n Dette inkluderer prisen på din reservation og et gebyr til dækning af eventuelle overskridelser. \n\n Uden overskridelse eller skader på køretøjet {bookingPrice} {currency} fra din konto.",
	"booking.deposit.db": "To bankindskud vil blive opkrævet, når du bekræfter din reservation:\n - Først en i mængden af {bufferPrice} {currency} , inklusive prisen på din reservation og et gebyr til dækning af eventuelle overskridelser.\n - Andet i mængden af {damageSafetyDeposit} {currency} til dækning af skader, der er forårsaget på køretøjet under din reservation. \n\n Uden overskridelse eller skader på køretøjet opkræves {bookingPrice} {currency}",
	"booking.deposit.info": "Et depositum placeres for din reservation",
	"booking.payment.prebilling.refused.error": "Transaktionen blev afvist, fordi debitering på dit kreditkort mislykkedes. Gentag venligst med et andet kort. Hvis problemet fortsætter, skal du kontakte din bank.",
	"booking.payment.prebilling.technical.error": "Der opstod en fejl under betaling. Prøv igen senere.",
	"booking.success.sub.title": "Tak fordi du bruger vores service!",
	"booking.success.title": "Tillykke, din reservation er oprettet!",
	"booking.type.label": "Reservationstype",
	"booking.type.one_way": "Envejs",
	"booking.type.return_trip": "Returrejse",
	"booking.update.period.expired": "Perioden for opdatering af booking datoerne er udløbet",
	"booking.usage.business": "Erhverv",
	"booking.usage.private": "Privat",
	"booking.view_payment_terms.title": "Betalingsbetingelser",
	"booking.voucher.different.code": "Du kan ikke ændre din kampagnekode",
	"booking.voucher.placeholder": "Jeg har en kuponkode",
	"car.AUTOMATIC": "Automatisk",
	"car.DIESEL": "Diesel",
	"car.ELECTRIC": "Elektrisk",
	"car.FOLDING_SEATS": "Klapsæder",
	"car.GPS": "GPS",
	"car.HYBRID": "Hybrid",
	"car.LPG": "GPL",
	"car.MANUAL": "Manuelt",
	"car.PETROL": "Benzin",
	"car.RADIO_CD": "Radio",
	"car.booking_details": "Reservationsdetaljer",
	"car.color": "Farve",
	"car.compact_cars": "Kompakt",
	"car.description": "Description",
	"car.details": "Køretøjsdetaljer",
	"car.doors": "Døre",
	"car.filter.COMMERCIAL": "Kommerciel",
	"car.filter.PASSENGER": "Turisme",
	"car.filter.accessories.air_conditioning": "Aircondition",
	"car.filter.accessories.baby_seat": "Baby seat",
	"car.filter.accessories.bluetooth": "Bluetooth",
	"car.filter.accessories.large_truck": "Stor lastvogn",
	"car.filter.accessories.radio_cd": "Radio",
	"car.filter.label_nb_persons": "Antal personer",
	"car.filter.other": "Andre",
	"car.filter.other-nb": "Andre - {nb}",
	"car.filter.vehicle_type": "Køretøjstype",
	"car.filter_energy": "Energi",
	"car.filter_gearbox_type": "Gearkassetype",
	"car.filter_persons": "Folk",
	"car.for_every_additional_km": "Pr. ekstra kilometer",
	"car.km_included": "Km inkluderet",
	"car.motorization": "Motorisering",
	"car.options": "Valgmuligheder",
	"car.parking_additional_info": "Parkeringsspecifikke detaljer",
	"car.places": "Pladser",
	"car.pricing": "Prissætning",
	"car.pricing.estimate": "Prisestimat",
	"car.pricing.extra_km_cost_per_day": "Pris for ekstra km",
	"car.pricing.free_km_per_day": "Km inkluderer/ 24 timer",
	"car.specifications": "Specifikationer",
	"car.transmission": "Gearkasse",
	"car.utility_cars": "Varevogn",
	"car.version": "Version",
	"company.id.missing.booking.search": "Virksomheds-id er obligatorisk for den anonyme reservationssøgning",
	"contact_page.phone_call_price": "(GRATIS OPKALD FRA EN FAST FORBINDELSE)",
	"contact_page.title_1": "For spørgsmål vedrørende din billeje,",
	"contact_page.title_2": "tøv ikke med at kontakte os via e-mail.",
	"creditcard.data.insufficient.3ds": "På grund af nye 3DS2-krav beder vi dig om at opdatere dine betalingsoplysninger.",
	"custom.field.type.boolean": "Ja/Nej",
	"data.with.colon": "{data}:",
	"document.issue.date": "Udstedelsesdato",
	"dropzone.inner.info": "Tilladte filer: JPEG, PNG, PDF",
	"dropzone.inner.title": "Upload dit dokument",
	"error.booking.member_invalid": "Din profil er endnu ikke blevet godkendt.",
	"error.booking.no.usage": "Ingen brug for disse reservationsdatoer",
	"error.booking.no_credit_card": "Tilføj først dine kreditkortoplysninger.",
	"error.booking.same_period": "Du har allerede planlagt en reservation for denne periode.",
	"error.change_password.400.bad_request": "Adgangskode er forkert",
	"error.contract.inactive": "Tjenesten er ikke aktiv for din virksomhed. Kontakt din servicechef.",
	"error.contract.not-found": "Tjenesten er suspenderet af din virksomhed. Kontakt din servicechef.",
	"error.credit.card.refused": "Kreditkort afvist",
	"error.forgot_password.404": "Tjek venligst din e-mail, ingen konto matcher",
	"error.form.email.already_exists": "Indtast en anden e-mailadresse",
	"error.form.email_invalid": "Indtast en gyldig e-mail",
	"error.form.inviteCode.notEmpty": "Angiv en invitationskode",
	"error.form.password.at_least": "Din adgangskode skal indeholde mindst 8 tegn",
	"error.form.password.at_most": "Din adgangskode må maksimalt indeholde 25 tegn",
	"error.form.password.cannot_reset_same": "Den nye adgangskode skal være forskellig fra den nuværende",
	"error.form.password.digit": "Din adgangskode skal indeholde 1 tal",
	"error.form.password.lower_letter": "Din adgangskode skal indeholde 1 lille bogstav",
	"error.form.password.upper_letter": "Din adgangskode skal indeholde 1 stort bogstav",
	"error.form.password_confirmation.the_same": "Indtast den samme adgangskode to gange",
	"error.form.password_old.the_same": "Den nye adgangskode skal være forskellig fra de tidligere anvendte adgangskoder",
	"error.form.required": "Udfyld venligst alle obligatoriske felter",
	"error.form.suggestion.address.required": "Vælg adressen på listen over forslag",
	"error.form.technical": "Teknisk fejl",
	"error.get.site.config": "Webstedskonfigurationen kunne ikke indlæses",
	"error.invite.code.invalid": "Det fællesskab, du vil deltage i, eksisterer ikke",
	"error.login.401.unauthorized": "Din e-mail eller adgangskode er forkert",
	"error.login.403.user.anonymized": "Din konto bliver anonymiseret, du kan ikke længere bruge den",
	"error.login.422.user.not.enabled": "Din konto er ikke aktiveret. Tjek venligst dine e-mails og følg vejledningen for at aktivere din konto.",
	"error.number.above.max": "Værdien kan ikke være over {value}",
	"error.number.below.min": "Værdien kan ikke være under {value}",
	"error.phone.format.invalid": "Telefonnummerformat er ugyldigt",
	"error.register.without.sso": "You can only subscribe using SSO",
	"error.request_error": "Anmodningsfejl",
	"error.reset_password.401": "Det angivne link er ikke længere gyldigt, anmod venligst om en anden adgangskode på hjemmesiden",
	"error.search.vehicles.403": "Du kan ikke få adgang til det valgte websted med den aktuelle aktive profil",
	"error.session.expired": "Session udløbet",
	"error.text.length.long": "Dette felt er begrænset til {count} tegn",
	"error.text.length.short": "Dette felt skal have mindst {count} tegn",
	"error.user.verify.fail": "User verification failed",
	"error_profile_edit_member_approved": "Navn og fødselsdag kan ikke ændres, når din profil er godkendt",
	"faq.contactEmailFallback": "vores kontakt e-mail",
	"faq.contactPhoneFallback": "Bunden af siden",
	"faq.other_question": "Kan du ikke finde svaret på dit spørgsmål?",
	"file_upload_size_exceeded": "Filen er for stor. Maksimal størrelse: 5 MB",
	"footer.label.legal.information": "Juridiske oplysninger",
	"footer.label.personal.data": "Personlig data",
	"footer_callUs": "Ring til os",
	"footer_other": "Andet",
	"footer_share": "Følg os",
	"footer_society_about": "Om os",
	"footer_society_policy_privacy": "Privatlivspolitik",
	"footer_society_term": "Betingelser for brug",
	"footer_writeUs": "Send en e-mail",
	"forgot_password.confirmation": "Et link til at nulstille din adgangskode er sendt til din e-mailadresse.",
	"forgot_password.description_line1": "Indtast e-mail, der er knyttet til din konto.",
	"forgot_password.description_line2": "Vi sender dig et link for at nulstille din adgangskode.",
	"forgot_password.submit": "Linket Send mig nulstilling",
	"generic.address": "Adresse",
	"generic.at": "på",
	"generic.book": "Book",
	"generic.cancel": "Annuller",
	"generic.canceled": "Annulleret",
	"generic.city": "By",
	"generic.clear": "Klar",
	"generic.company": "Firma",
	"generic.completed": "Afsluttet",
	"generic.country": "Land",
	"generic.email": "E-mail",
	"generic.end": "Slut",
	"generic.expires.at": "Udløber",
	"generic.extend": "Udvid",
	"generic.file": "Fil",
	"generic.first.name": "Fornavn",
	"generic.last.name": "Efternavn",
	"generic.location.fixture.label": "Steder",
	"generic.location.history.label": "Historie",
	"generic.location.search.placeholder": "Søg efter en adresse, en by...",
	"generic.mobile.phone": "Mobiltelefon",
	"generic.modify": "Modify",
	"generic.mr": "Hr.",
	"generic.mrs": "Fru",
	"generic.next": "Næste",
	"generic.number": "Nummer",
	"generic.passport": "Pas",
	"generic.past.placeholder": "Find dine tidligere reservationer her",
	"generic.phone.number": "Telefonnummer",
	"generic.postal.code": "Postnummer",
	"generic.retry": "Prøv igen",
	"generic.save": "Gem",
	"generic.send": "Send",
	"generic.start": "Start",
	"generic.text": "Tekst",
	"generic.today": "I dag",
	"generic.upcoming": "Kommende",
	"generic.updated": "Opdateret",
	"generic.user": "Bruger",
	"get.sso.config.fail": "This email address is not recognized for SSO login",
	"helpPage_carSharing_issue1_answer": "For at registrere dig skal du blot gå til din virksomheds intranetside, hvor du vil finde et link der tager dig til registreringsgrænsefladen. (Eller send en anmodning om inkludering til {contactEmail}). Du vil modtage et link på e-mail.",
	"helpPage_carSharing_issue1_title": "Hvordan registrer man sig?",
	"helpPage_carSharing_issue2_answer": "Du kan nulstille din adgangskode fra hjemmesiden eller mobilapps: i dette tilfælde modtager du på din registrerede e-mailadresse et link til at indstille din nye adgangskode.",
	"helpPage_carSharing_issue2_title": "Hvad gør jeg hvis jeg har mistet min adgangskode?",
	"helpPage_carSharing_issue3_answer": "Hvis du har mistet dit mærke eller har et nyt, bedes du kontakte callcenteret på {contactPhone} for at nulstille dit mærke. Et nyt mærke vil ikke virke, medmindre det bliver nulstillet først.",
	"helpPage_carSharing_issue3_title": "Hvad gør jeg hvis jeg har mistet mit mærke eller har et nyt?",
	"helpPage_carSharing_issue4_answer": "Dit køretøjs nummerplade er noteret i bekræftelsesmailen og i bekræftelses-SMS'en. Ellers kan du finde køretøjet på reservationssiden Mine reservationer.",
	"helpPage_carSharing_issue4_title": "Hvilket køretøj har jeg reserveret?",
	"helpPage_carSharing_issue5_answer": "Sørg for at datoen og tidspunktet er korrekt. Startknappen er kun tilgængelig fra reservationstidspunktet. Ellers kan du indlæse dit mærke på kortlæseren for at åbne køretøjets døre.",
	"helpPage_carSharing_issue5_title": "Hvorfor kan jeg ikke finde startknappen?",
	"helpPage_carSharing_issue6_answer": "Hvis du har foretaget en reservation og lyset bliver grønt, men døren ikke åbner sig, skal du trykke på knappen der sidder på dørhåndtaget.",
	"helpPage_carSharing_issue6_title": "Hvorfor lyser det grønt, mens dørene stadig er lukkede?",
	"helpPage_carSharing_issue7_answer": "Når du har reserveret køretøjet, kan du også redigere eller annullere din reservation, fra hjemmesiden eller mobilappen. Hvis du har brug for hjælp, bedes du kontakte callcenteret på {contactPhone}.",
	"helpPage_carSharing_issue7_title": "Rediger / Annullering",
	"helpPage_carSharing_issue8_answer": "Du kan ikke bruge mærket på forhånd. Du kan kun åbne køretøjet med start på det rette tidspunkt.",
	"helpPage_carSharing_issue8_title": "Kan jeg indlæse mærket på forhånd?",
	"helpPage_damages_issue1_answer": "Før du starter din reservation, skal du sørge for at give besked om skaderne med din mobilapp eller ved at ringe til callcenteret på {contactPhone}.",
	"helpPage_damages_issue1_title": "Hvad gør jeg hvis det reserverede køretøj blive beskadiget?",
	"helpPage_damages_issue2_answer": "Tag det roligt og sørg for at ingen er såret. Du er dækket af forsikringen. Kontakt venligst callcenteret HURTIGT på {contactPhone} for yderligere instruktioner.",
	"helpPage_damages_issue2_title": "Hvad gør jeg hvis der sker en ulykke under min reservation?",
	"helpPage_subtitle": "I denne sektion finder du svar på de oftest stillede spørgsmål.",
	"helpPage_tab_carSharing": "Service",
	"helpPage_tab_damages": "Skader",
	"helpPage_tab_vehicles": "Køretøj",
	"helpPage_title": "Ofte stillede spørgsmål (F.A.Q)",
	"helpPage_vehicles_issue1_answer": "Tjek dine reservationsdatoer og tidspunkter og tjek derefter om nummerpladen matcher din reservation. Indlæs derefter igen ved KUN at præsentere dit mærke for læseren. Sørg for at du bruger det mærke der tilhører den samme person, som foretog reservationen og at det ikke er ændret siden den sidste booking. I tilfælde af en nyere ændring af mærket bedes du kontakte kundeservice for at foretage en ændring på et øjeblik.",
	"helpPage_vehicles_issue1_title": "Hvorfor reagerer køretøjet ikke?",
	"helpPage_vehicles_issue2_answer": "Tjek dine reservationsdatoer og tidspunkter og tjek derefter om nummerpladen matcher din booking. Sørg for at det korrekte mærke er i din besiddelse (mærket som tilhører den person foretog reserveringen).",
	"helpPage_vehicles_issue2_title": "Hvorfor viser kortlæseren kun rødt lys?",
	"helpPage_vehicles_issue3_answer": "Hvis du har en reservation og lyset er grønt, men du ikke hører dørene låse sig op, skal du trykke på knappen på chaufførdøren for at låse dørene op.",
	"helpPage_vehicles_issue3_title": "Hvorfor forbliver dørene lukkede?",
	"helpPage_vehicles_issue4_answer": "Noter køretøjets registreringsplade, dine datoer og tidspunkter og sørg for at du har en tilstrækkelig internetforbindelse.",
	"helpPage_vehicles_issue4_title": "Hvorfor kan jeg ikke åbne dørene?",
	"helpPage_vehicles_issue5_answer": "Sørg blot for at motoren er slukket, dørene og bagagerummet er forsvarligt lukket og at du har afleveret nøglerne med den lille chip i kassen, der er placeret i handskerummet.",
	"helpPage_vehicles_issue5_title": "Hvorfor kan jeg ikke låse køretøjet?",
	"home.header_banner": "I oktober bliver <strong> Renault Mobility </strong> <strong> Mobilize-aktie </strong>",
	"home.welcome": "Velkommen til {productName}",
	"home.welcome_solo": "Velkommen",
	"how_it_works.step_1": "<span class='bold'>Download applikationen</span> fra App Store eller Google Play.",
	"how_it_works.step_2": "Start applikation og <span class='bold'>registrer</span> ved at udfylde formularen.",
	"how_it_works.step_3": "Tag et billede af dit <span class='bold'>kørekort</span>, dit <span class='bold'>identitetskort</span> og <span class='bold'>tag et billede af dig selv</span> med dit ID-kort ved siden af dit ansigt, gem det hele i appen!",
	"how_it_works.step_4": "<span class='bold'>Registrer dit bankkort</span> for at administrere betalingen af dine huslejer.",
	"how_it_works.step_5": "<span class='bold'>Bekræft din e-mail-adresse</span> ved at klikke på det link, der er sendt til dig. <span class='bold'>Kontroller dine SPAM-mapper</span>.",
	"how_it_works.step_6": "Når din registrering er godkendt, <span class='bold'>skal du reservere dit køretøj</span> i vores ansøgning eller på vores hjemmeside. På dagen for din reservation, <span class='bold'> er din smartphone din nøgle!</span>",
	"info.account.company.already.linked": "Dette firma har allerede linket til din konto",
	"info.switch.profile": "<strong>New — </strong>You can now add and manage multiple profiles using the same credentials. This allows you to join corporate fleets of you company and use the same app to rent a vehicle for your week-ends.",
	"info.switching.profile": "Skifter profil",
	"info.worldpay.return.success": "Betalingsoplysninger vedhæftet",
	"iso__BE": "Belgien",
	"iso__CS": "Tjekkiet",
	"iso__DA": "Dansk",
	"iso__DE": "Tyskland",
	"iso__ES": "Spanien",
	"iso__FR": "Frankrig",
	"iso__IT": "Italien",
	"iso__NL": "Holland",
	"iso__PL": "Polen",
	"iso__PT": "Portugal",
	"iso__SL": "Slovenien",
	"iso__SV": "Sverige",
	"iso__pt_BR": "Brasilien",
	"label.accept_terms_and_conditions": "Jeg accepterer at blive kontaktet efterfølgende af Renault og dets netværk via e-mail med henblik på undersøgelse eller information om nye produkter såvel som aktuelle tilbud. I anledning af hver udsendelse vil jeg have mulighed for at afslutte al kommunikation.",
	"label.account.already.active": "Din konto er allerede aktiv",
	"label.account_activation_description": "Du modtager en bekræftelse via e-mail, når din konto er valideret, og du kan derefter få fuld fordel af tjenesten.",
	"label.account_activation_title": "Din konto vil blive godkendt inden for højst 15 minutter.",
	"label.activation.link.expired": "Aktiveringslink er udløbet",
	"label.activation.link.send": "Send igen",
	"label.activation.link.sent.success": "Aktiverings-e-mailen sendes, hvis brugeren eksisterer, og kontoen ikke er aktiveret",
	"label.active.profile": "Aktiv profil",
	"label.actual.payment.method": "Din aktuelle betalingsmetode",
	"label.add.new.profile": "Tilføj ny profil",
	"label.apply": "Anvende",
	"label.are_you_sure_you_want_to_cancel": "Vil du bekræfte din annullering?",
	"label.birth.day": "Fødselsdato",
	"label.booking": "Booking",
	"label.booking.past": "Tidligere",
	"label.booking.past.placeholder": "Find din reservationshistorik her",
	"label.booking.today.part": "i dag kl.",
	"label.booking.upcoming.placeholder": "Find dine planlagte og igangværende bookinger her",
	"label.cancel_my_booking": "Annuller min reservation",
	"label.car": "køretøj",
	"label.carSharing": "Bildeling",
	"label.cars": "køretøjer",
	"label.civility": "Civilstand",
	"label.click_here": "Klik her",
	"label.close": "Luk",
	"label.confirm_new_password": "Bekræft adgangskode",
	"label.congratulations": "Tillykke!",
	"label.continue": "Fortsæt",
	"label.creditCard_message": "For at validere dit kort foretages en midlertidig debitering. En debitering på et mindre beløb {amountToTake}€ kan muligvis ses midlertidigt på den konto, der er knyttet til dit kort. Hvis debiteringen fortsætter i mere end fem arbejdsdage, bedes du kontakte din bank.",
	"label.date": "Dato",
	"label.delivery_place": "Udsted by",
	"label.driving_licence": "Kørekort",
	"label.driving_licence_back": "Kørekort (bagside)",
	"label.driving_licence_front": "Kørekort (forside)",
	"label.edit.invite.code": "Rediger invitationskode",
	"label.expiration_date": "Udløbsdato",
	"label.file.upload.only.mobile": "Brug mobilappen til at redigere dokumenter.",
	"label.filter_by": "Filtrer efter",
	"label.filters": "Filtre",
	"label.generic.error": "Der opstod en fejl. Prøv venligst igen senere.",
	"label.hours": "timer",
	"label.how_it_works": "Hvordan virker det?",
	"label.identity.card": "ID-kort",
	"label.identity.document.number": "Identitetsdokument-nummer",
	"label.identity.document.type": "Identitetsdokumenttype",
	"label.identity_card": "Identitetsdokument",
	"label.identity_card_back": "Identitetsdokument (bagside)",
	"label.identity_card_front": "Identitetsdokument (forside)",
	"label.identity_card_selfie": "Selfie med dit identitetsdokument",
	"label.invite_code_placeholder": "Indtast din invitationskode",
	"label.italy.fiscal.code": "Angiv regnskabsnummer",
	"label.italy.resident": "Er du italiener?",
	"label.licence_number": "Kørekortnummer",
	"label.load_more": "Flere resultater",
	"label.login": "Log ind",
	"label.logout": "Log ud",
	"label.manager.email": "E-mail til din manager",
	"label.mandatory_fields": "* Obligatoriske felter",
	"label.member_already": "Allerede medlem?",
	"label.my_account": "Min konto",
	"label.my_reservations": "Mine bookinger",
	"label.new.password": "Ny adgangskode",
	"label.no_account": "Nyt medlem?",
	"label.or_by_phone": "Eller pr. telefon",
	"label.password": "Adgangskode",
	"label.password_forgot": "Adgangskode glemt",
	"label.phone": "Telefon",
	"label.phone.suffix": "Telefonsuffiks",
	"label.plateNumber": "Nummerplade",
	"label.price": "pris",
	"label.redirectMobileApp": "Download vores mobilapp for at starte din reservation!",
	"label.remember_me": "Forbliv logget på",
	"label.reset_password_done": "Din adgangskode er blevet opdateret",
	"label.return": "Tilbage",
	"label.schedule": "Timer",
	"label.search": "Søg",
	"label.selected.language": "Valgt sprog",
	"label.subject": "Emne",
	"label.switch.profile": "Skift profil",
	"label.the": "til",
	"label.validate": "Godkend",
	"label.vehicles_found": "{count} resultater fundet",
	"label.warning": "Advarsel",
	"label.welcome.finish.registration": "Afslut din registrering for at bekræfte din aftale.",
	"label.you_are_trying_to_cancel_your_booking": "Du er ved at annullere din reservation!",
	"label.your.active.profile": "Din aktive profil",
	"label.your.other.profiles": "Dine andre profiler",
	"label.your_message": "Din besked",
	"language.header": "Vælg dit sprog",
	"login.forgot_password": "Har du glemt din adgangskode?",
	"login.register": "Registrer",
	"menu.faq": "Information",
	"mobile_banner.text": "Download applikationen {productName}",
	"page.password.update.sub.title": "Af sikkerhedsmæssige årsager beder vi dig om at opdatere din adgangskode",
	"page.password.update.title": "Opdatering af adgangskode",
	"parking.special_opening_legend": "Særlige åbningstider",
	"part.company.fill.extra.info": "beder dig om at udfylde yderligere oplysninger",
	"part.complete.register.for": "Udfyld din registrering for",
	"part.create.account.for": "Opret en konto til",
	"part.link.account.to": "Link din konto til",
	"part.your.email": "din email",
	"placeholder.enter.number": "Indtast et nummer ...",
	"placeholder.enter.text": "Skriv her ...",
	"placeholder.search": "Søg ...",
	"profile.422.error.info": "Det ser ud til, at der mangler nogle oplysninger i din profil.\n Lad os verificere din profil sammen for at sikre, at alt er i orden.",
	"profile.info.new.email": "Hvis du opdaterer din e-mailadresse, modtager du en e-mail for at bekræfte din e-mailadresse. Uden at bekræfte den kan du ikke længere oprette en reservation.",
	"profile.label.before.arrival": "Inden ankomst",
	"profile.label.before.departure": "Inden afrejse",
	"profile.label.charges.call.center": "For ændringer lavet på mine vegne",
	"profile.label.charges.my": "For ændringer foretaget af mig",
	"profile.label.current.password": "Nuværende adgangskode",
	"profile.label.expiration.date.status": "Mit kørekort har ikke en udløbsdato",
	"profile.label.min.15": "15 minutter",
	"profile.label.min.30": "30 minutter",
	"profile.label.min.45": "45 minutter",
	"profile.label.new.email": "Ny e-mailadresse",
	"profile.label.street.field": "Adresse (gadenummer + gadenavn)",
	"profile.label.validated.email": "Din godkendte e-mailadresse",
	"profile.section.additional.info": "Yderligere information",
	"profile.section.credentials": "Legitimationsoplysninger",
	"profile.section.language": "Profil sprog",
	"profile.section.notifications": "Notifikationer og advarsler",
	"profile.section.payment.info": "Betalingsinformation",
	"profile.section.personal.info": "Personoplysninger",
	"profile.section.selfie": "Selfie",
	"profile.section.technician.access": "Adgang til teknikere",
	"profile.select.menu.item": "Vælg et menupunkt til venstre",
	"profile.selfie.section.info": "Tag en selfie med dit identitetsdokument ved siden af dit ansigt",
	"profile.suspended": "Din profil er suspenderet",
	"profile.title.email.notifications": "E-mailnotifikationer",
	"profile.title.language.select": "Sprog, der bruges til underretninger og e-mails",
	"profile.title.sms.notifications": "SMS-notifikationer",
	"profile.title.update.email": "Opdater din e-mailadresse",
	"profile.title.update.password": "Opdater din adgangskode",
	"profile_error_driver_license_invalid": "Kørekortet er ikke gyldigt",
	"register.field.info.password": "Skal indeholde mindst 1 tal, 1 stort bogstav, 1 lille bogstav og mellem 8 og 25 tegn",
	"register.info.payment.saved": "Betalingsmetode gemt",
	"register.info.profile.creation.forbidden": "You can't link your profile to this company",
	"register.success.info": "Et aktiveringslink er sendt til {email}. Kontroller din e-mail og din spam-mappe, og følg derefter instruktionerne for at aktivere din konto, før linket udløber.",
	"register.terms.ads": "Jeg giver mit samtykke til behandling af mine data til markedsføringsformål (med både automatiserede og traditionelle metoder) i forbindelse med mobilitetsprodukter og/eller -tjenester",
	"register.terms.prefix.accept": "Jeg accepterer",
	"register.terms.privacy.link.label": "Privacy policy",
	"register.terms.privacy.text": "I accept the {link} of {company}",
	"register.terms.root.privacy": "Privatlivspolitik",
	"register.terms.root.tos": "abonnementsbetingelser",
	"register.terms.root.tou": "betingelser for brug",
	"register.terms.suffix.ads": "brug af mine oplysninger til kommercielle formål",
	"register.terms.suffix.of": "af",
	"register.terms.usage.link.label": "Terms of use",
	"register.terms.usage.subscription.link.label": "Terms of subscription",
	"register.terms.usage.subscription.text": "I accept the {link} of {company}",
	"register.terms.usage.text": "I accept the {link} of {company}",
	"register.title.account.created": "Tillykke {firstName}, din konto er blevet oprettet",
	"register.title.account.linked": "Tillykke {firstName}, ny profil er blevet knyttet til din konto",
	"register.title.account.updated": "Tillykke {firstName}, din konto er blevet opdateret",
	"reset_password.title": "Nulstil kodeord",
	"search.filter_alphabetically": "Alfabetisk",
	"search.filter_by": "Sorter efter",
	"search.filter_by_price": "Efter pris",
	"search.result.empty": "Der er intet resultat",
	"service.corporate.intro": "Vil du deltage i et fællesskab? Indtast din invitationskode.",
	"service.intro_label": "Hvilken {productName}-tjeneste vil du gerne abonnere på?",
	"service.private.intro": "Vil du reservere et køretøj fra {productName} Network?",
	"service.private.renaultfr": "For at abonnere på {productName} skal du downloade appen i din mobilbutik.",
	"service.private.select_country": "Vælg et land",
	"service.usage.corporate": "Virksomhedsbildeling",
	"service.usage.private": "Biludlejning 24/7",
	"service.usage.vr": "Udskiftningskøretøj",
	"service.vr.intro": "Tak for din interesse for vores service!\n\nFor at blive medlem, bedes du kontakte din forhandler for at få et registreringslink.",
	"sncf.home.login.msg": "Are you an SNCF employee? Log in.",
	"sso.login.description": "Indtast din arbejdsmailadresse",
	"sso.login.title": "Opret forbindelse til SSO",
	"status.APPROVED": "Profil valideret",
	"status.NOT_APPROVED": "Din profil afvises. Opdater venligst din profil.",
	"status.TO_COMPLETE": "Ufuldstændig",
	"status.TO_REVIEW": "Din profil afventer validering",
	"tagline": "Biludlejning selvbetjening 24/7",
	"title.add.payment.later": "Du kan tilføje det senere.",
	"title.add.payment.method": "Tilføj venligst en betalingsmetode.",
	"title.bookings.welcome.tutorial": "Find her din reservation, den er allerede planlagt",
	"title.modify.booking": "Rediger min reservation",
	"title.password.change.success": "Din nye adgangskode er blevet gemt",
	"title.update.booking": "Opdater booking",
	"title.welcome.to.brand": "Hej {firstName}, velkommen til {brandName}.",
	"title.welcome.to.program": "Hej {firstName}, velkommen til programmet {brandName} {program}.",
	"vehicle.incorrect.usage": "Køretøjet er ikke til rådighed for denne brugstype",
	"week.day.friday": "Fredag",
	"week.day.monday": "Mandag",
	"week.day.saturday": "Lørdag",
	"week.day.sunday": "Søndag",
	"week.day.thursday": "Torsdag",
	"week.day.tuesday": "Tirsdag",
	"week.day.wednesday": "Onsdag"
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/i18n/da.json
 ** module id = 419
 ** module chunks = 0
 **/